<template>
  <div class="appRef">
    <!-- <div> -->
    <NavBar></NavBar>
    <!-- <keep-alive> -->
    <router-view> </router-view>
    <!-- </keep-alive> -->

    <TabBars></TabBars>
    <!-- </div> -->
  </div>
</template>

<script>
// import TabBar from '@/components/TabBar.vue';
import NavBar from "@/components/NavBar.vue"
import TabBars from "@/components/TabBars.vue"

export default {
  components: {
    NavBar,
    TabBars,
  },
  props: {},
  watch: {
    "$i18n.locale" (newVal, oldVal) {
      console.log(newVal, oldVal)
      // if (newVal !== oldVal) {
      //   this.reload()
      // }
    },
  },
  data () {
    return {
      name: "App",
      // show: true,
    }
  },
  created () {
    // const userAgent = navigator.userAgent;
    // console.log(userAgent,'区分设备');
    const userAgent = window.navigator.userAgent

    if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
      // console.log('移动端')
      // alert('移动端')
			window.open ('http://m.boaordmc.com/#/','_self') 
    } else {
      console.log('pc端')
      // alert('pc端')
    }
    // this.$router.afterEach((to, from) => {
    //   if (to.path == "/medical/news/details") {
    //     // this.show = false;
    //   } else {
    //     // this.show = true;
    //   }
    //   // console.log('当前路由对象：', to);
    // });
  },

  methods: {},
}
</script>
<style lang="scss">
@import "../src/assets/font/font.css";

#app {
  height: 100vh;
  width: 100vw;
}

html,
body {
  margin: 0px !important;
  box-sizing: border-box;
  height: 100vh;

  .ant-menu-submenu-popup::before {
    position: absolute;
    top: -10px;
    right: 0;
    bottom: 0;
    left: -1920px !important;
    opacity: 1 !important;
    content: " ";
    width: 3840px !important;
    background: #fff;
    z-index: -10;
  }

  .ant-menu {
    background: none !important;
    box-shadow: none !important;

    .ant-menu-submenu {
      height: 100px;
      line-height: 120px;
      display: flex;
      align-items: center;
    }

    .ant-menu-submenu-active {
      // border-bottom: 1px solid #0BA39A;

      .ant-menu-submenu-title {
        color: #0ba39a !important;
      }
    }

    .ant-menu-submenu-open {
      color: #0ba39a !important;
    }

    // .ant-menu-submenu-selected {
    //   border-bottom: 1px solid #0BA39A;
    // }
  }

  .ant-menu-horizontal>.ant-menu-item:hover,
  .ant-menu-horizontal>.ant-menu-submenu:hover,
  .ant-menu-horizontal>.ant-menu-item-active,
  .ant-menu-horizontal>.ant-menu-submenu-active,
  .ant-menu-horizontal>.ant-menu-item-open,
  .ant-menu-horizontal>.ant-menu-submenu-open,
  .ant-menu-horizontal>.ant-menu-item-selected,
  .ant-menu-horizontal>.ant-menu-submenu-selected {
    border-bottom: 6px solid #0ba39a;
    color: #000000;
    // margin-top: 20px;
  }

  .ant-menu-submenu>.ant-menu {
    background: none !important;
    margin-top: 20px;
    font-family: "PingFang SC";
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 20px;

    .ant-menu-item {
      font-family: "PingFang SC";
      font-size: 20px;
      font-weight: 600;

      a:hover {
        color: #0ba39a;
      }
    }
  }
}

@font-face {
  font-family: "PingFang SC";
  src: url("./assets/font/PingFangRegular.ttf");
}
</style>
